(function () {
	'use strict';

	angular.module('dcApp').constant('META_DATA_CATALOGUE_REF_STATUS', {
		active: 'active',
		inactive: 'inactive',
	});

	angular.module('dcApp').directive('metaData', [
		'$parse',
		function ($parse) {
			var controller = [
				'$http',
				'API_BASE_URL_BACKEND',
				'$scope',
				'$rootScope',
				'TagService',
				'$stateParams',
				'META_DATA_CATALOGUE_REF_STATUS',
				'PictogrammeService',
				'PAGINATIONS_SIZE',
				'PAGINATIONS_SIZES',
				'$timeout',
				'MetadataService',
				'toaster',
				'permissionChecker',
				'gettextCatalog',
				function (
					$http,
					API_BASE_URL_BACKEND,
					$scope,
					$rootScope,
					TagService,
					$stateParams,
					META_DATA_CATALOGUE_REF_STATUS,
					PictogrammeService,
					PAGINATIONS_SIZE,
					PAGINATIONS_SIZES,
					$timeout,
					MetadataService,
					toaster,
					permissionChecker,
					gettextCatalog
				) {
					var vm = this;
					vm.metadataCatalogueRefStatus = META_DATA_CATALOGUE_REF_STATUS;
					vm.havePermission = $rootScope.havePermission;

					$scope.confirmationData = {};
					$scope.iconsSelector = {};
					$scope.currentMode = undefined;

					$scope.tagToEditIndex = undefined;
					$scope.tag = {};

					$scope.availableTags = [];
					$scope.availableGroupingTags = [];

					$scope.API_BASE_URL_BACKEND = API_BASE_URL_BACKEND;
					$scope.meta = {
						imageURL: API_BASE_URL_BACKEND + 'pictogramme_image?id=',
					};

					let dataGirdColumnName = {
						label: gettextCatalog.getString('Libellé'),
						picture: gettextCatalog.getString('Image'),
					};
					let referencedUpdated = false;

					$scope.sortableOptions = {
						'ui-floating': true,
						stop: function () {
							updateTagPosition(vm.data.tags, $scope.availableTags);
						},
					};

					$scope.elementAlreadySelected = elementAlreadySelected;
					$scope.tagLabelColor = tagLabelColor;

					vm.searchTags = function ($query) {
						return $http
							.get(API_BASE_URL_BACKEND + 'tags/?tag' + $query)
							.then(function (response) {
								return response;
							});
					};

					$scope.cancelAdvanced = function (id) {
						$('#advancedDataModal-' + id).modal('hide');
					};

					$scope.saveAdvanced = function (id) {
						$('#advancedDataModal-' + id).modal('hide');
					};

					vm.checkError = function (fieldName) {
						return $rootScope.checkErrorBoolean(fieldName);
					};

					$scope.intiated = false;

					$scope.$watch(
						angular.bind(this, function () {
							return this.data;
						}),
						function (newVal, oldValue) {
							if (newVal !== undefined) {
								getMetadataIcon();
								buildIconUrl();
								$scope.metadataPopover = {};
								vm.init();
								$scope.intiated = true;
							} else {
								if (!$scope.intiated) {
									$scope.imageURL = $scope.meta.imageURL + '-1';
									$scope.intiated = false;
								}
							}
						}
					);

					vm.init = function () {
						$scope.htmlId =
							vm.config && vm.config.htmlId ? vm.config.htmlId : '';
						if (!vm.isNew) {
							// edit or duplicate
							vm.hide_advanced = true;
						}
						vm.data.tags = _.sortBy(vm.data.tags, function (elm) {
							return elm.position;
						});
						vm.data.groupingTags = _.sortBy(
							vm.data.groupingTags,
							function (elm) {
								return elm.position;
							}
						);

						vm.metadataInfo = {
							id: vm.elementId,
							code: vm.data.code,
							updateDate: vm.data.update_date,
							creationDate: vm.data.creation_date,
							createdBy: vm.data.created_by,
							updatedBy: vm.data.updated_by,
							metadataId:
								vm.data.metadata_id != undefined
									? vm.data.metadata_id
									: vm.data.id,
						};

						permissionChecker.checkGlobalPermission(
							'tags',
							() => {
								getAvailableTags();
								getAvailableGroupingTags();
							},
							() => {}
						);
					};

					vm.sortTags = function () {
						vm.data.tags = _.sortBy(vm.data.tags, function (elm) {
							return elm.position;
						});
					};

					$scope.getDateTimeWithPattern = function (date) {
						return $rootScope.getDateTimeWithPattern(date);
					};

					$scope.saveAttachedPictogrammes = function (iconId) {
						if (iconId != -1) {
							vm.data.icon_id = iconId;
						} else {
							vm.data.icon_id = -1;
						}

						buildIconUrl();
					};

					$scope.selectIcon = function () {
						$scope.iconsSelector.saveSelection =
							$scope.saveAttachedPictogrammes;
						$scope.iconsSelector.showIconsSelector = true;
					};

					$scope.deleteTag = function (index) {
						vm.data.tags.splice(index, 1);
						updateTagPosition(vm.data.tags, $scope.availableTags);
					};

					$scope.deleteGroupingTag = function (index) {
						vm.data.groupingTags.splice(index, 1);
						updateTagPosition(
							vm.data.groupingTags,
							$scope.availableGroupingTags
						);
					};

					$scope.updateTag = function (index, modalId, mode) {
						$scope.currentMode = mode;
						if (mode === 'element') {
							$scope.tagToEditIndex = index;
							$scope.tag = angular.copy(vm.data.tags[index]);
							if ($scope.tag) {
								$scope.tag.color = $scope.tag.color
									? $scope.tag.color
									: '#dbf5d1';
								$('#' + modalId + $scope.htmlId).modal('show');
							}
						}
					};

					$scope.saveTag = function (modalId) {
						let targetTags = [];
						let available = [];
						let tagToSave = undefined;
						let tagIdx = -1;
						let tagsRefresherCb = () => {};
						let query;

						if ($scope.currentMode === 'element') {
							targetTags = vm.data.tags;
							available = $scope.availableTags;
							tagToSave = $scope.tag;
							tagIdx = $scope.tagToEditIndex;
							tagsRefresherCb = getAvailableTags;
						}

						TagService.saveTag(tagToSave, $scope.currentMode).then(function (
							response
						) {
							if (tagIdx !== undefined) {
								targetTags[tagIdx] = response.data;
							} else {
								targetTags.push(response.data);
							}
							let message =
								tagIdx !== undefined
									? gettextCatalog.getString('Modification du Tag effectuée')
									: gettextCatalog.getString('Création du Tag effectuée');
							toaster.pop(
								'success',
								gettextCatalog.getString('Succès'),
								message
							);
							$('#' + modalId + $scope.htmlId).modal('hide');
							$scope.currentMode = undefined;
							updateTagPosition(targetTags, available);
							// update available tags
							tagsRefresherCb();
						});
					};

					$scope.tagSelected = function (tag, modalId, mode) {
						let targetTags = [];
						let availableTags = [];

						$scope.currentMode = mode;

						if (mode === 'element') {
							targetTags = vm.data.tags;
							availableTags = $scope.availableTags;
						} else if (mode === 'grouping') {
							targetTags = vm.data.groupingTags;
							availableTags = $scope.availableGroupingTags;
						}

						if (tag.selected) {
							const index = _.findIndex(targetTags, { code: tag.code });
							if (index > -1) {
								targetTags.splice(index, 1);
								updateTagPosition(targetTags, availableTags);
							}
							tag.selected = false;
							$scope.selectTag = {};
							$scope.selectedGroupingTags = {};
							return;
						}

						let maxTags = mode === 'element' ? 10 : 4;
						if (targetTags.length >= maxTags) {
							const msg =
								mode === 'element'
									? gettextCatalog.getString('project.metadata.tags.max-count')
									: gettextCatalog.getString(
											'project.metadata.groupingTags.max-count'
									  );
							toaster.pop('error', gettextCatalog.getString('Erreur'), msg);
							return;
						}

						if (tag.searchValue) {
							let tagSearch = _.find(
								availableTags,
								(t) => t.code === tag.searchValue
							);
							if (!tagSearch) {
								tag = { create: true, searchValue: tag.searchValue };
							} else {
								tag = tagSearch;
							}
						}
						// Only element tags can be created from the selector; domain tags
						// are picked from the existing catalogue.
						if (tag.create && mode === 'element') {
							$scope.tagToEditIndex = undefined;
							$scope.tag = { color: '#dbf5d1', code: tag.searchValue };
							$('#' + modalId + $scope.htmlId).modal('show');
						} else if (tag && tag.code && !tag.selected) {
							targetTags.push(tag);
						}

						// Refresh selected
						_.each(availableTags, (elm) => {
							elm.selected = elementAlreadySelected(targetTags, elm);
						});
						$scope.selectTag = {};
						$scope.selectedGroupingTags = {};
					};

					$scope.tagTransform = function (newTag) {
						let tag = {
							code: newTag + ' (' + gettextCatalog.getString('Nouveau') + ')',
							searchValue: newTag,
							color: 'white',
						};

						return tag;
					};

					$scope.addDataCatalogue = function () {
						referencedUpdated = true;
					};

					$scope.closeDialogAction = function () {
						if (referencedUpdated) {
							referencedUpdated = false;
							return;
						}
						vm.data.referenced = !vm.data.referenced;
						referencedUpdated = false;
					};

					$scope.showAddDataCatalogue = function () {
						if (vm.datacatalogueDisabled) {
							return;
						}
						if (vm.data.referenced) {
							$scope.confirmationData.confirmationDialogTitle =
								gettextCatalog.getString('Ajouter au DataCatalogue');
							$scope.confirmationData.confirmationDialogMessage =
								gettextCatalog.getString(
									'metadata.fields.dataCatalogue.confirmation'
								);
							$scope.confirmationData.confirmationDialogActionName =
								gettextCatalog.getString('Ajouter');
							$scope.confirmationData.confirmationGreenAction = true;
						} else {
							$scope.confirmationData.confirmationDialogTitle =
								gettextCatalog.getString('Retirer du DataCatalogue');
							$scope.confirmationData.confirmationDialogMessage =
								gettextCatalog.getString(
									"Êtes-vous sûr de vouloir desactiver l'option DataCatalogue ? "
								);
							$scope.confirmationData.confirmationDialogActionName =
								gettextCatalog.getString('Désactiver');
							$scope.confirmationData.confirmationGreenAction = false;
						}
						$scope.confirmationData.enableConfirmDialogAction = true;
						$scope.confirmationData.confirmDialogAction =
							$scope.addDataCatalogue;
						$scope.confirmationData.closeDialogAction =
							$scope.closeDialogAction;
						$scope.confirmationData.showConfirmationDialog = true;
					};

					$scope.closeMe = function (modalId) {
						$('#' + modalId + $scope.htmlId).modal('hide');
					};

					$scope.setActiveIndex = function ($select) {
						$timeout(() => {
							if ($select.selected === undefined) {
								$select.activeIndex = -1;
							}
						}, 25);
					};

					// -------------------
					// 	private functions
					// -------------------
					function getAvailableTags(search) {
						search = search !== undefined ? search : '';
						$scope.selectTag = {};
						loadTags(search).then(function (response) {
							//sort and check if selected
							$scope.availableTags = _.sortBy(response.data, function (tag) {
								tag.selected = elementAlreadySelected(vm.data.tags, tag);
								return tag.code && tag.code.toLowerCase();
							});
							// Add "new tag option"
							$scope.availableTags.unshift({
								code: gettextCatalog.getString('Nouveau Tag'),
								color: 'white',
								create: true,
							});
						});
					}

					function getAvailableGroupingTags(search) {
						search = search !== undefined ? search : '';
						$scope.selectedGroupingTags = {};
						loadGroupingTags(search).then(function (response) {
							//sort and check if selected
							$scope.availableGroupingTags = _.sortBy(
								response.data,
								function (tag) {
									tag.selected = elementAlreadySelected(
										vm.data.groupingTags,
										tag
									);
									return tag.code && tag.code.toLowerCase();
								}
							);
						});
					}

					function loadTags(search) {
						if (search) {
							return $http.get(`${API_BASE_URL_BACKEND}tags?text=${search}`);
						}
						return $http.get(`${API_BASE_URL_BACKEND}tags`);
					}

					function loadGroupingTags(search) {
						return $http.get(`${API_BASE_URL_BACKEND}grouping_tags/all`);
					}

					function buildIconUrl() {
						vm.data.icon_id =
							vm.data.icon_id != undefined ? vm.data.icon_id : -1;
						$scope.imageURL = $scope.meta.imageURL + vm.data.icon_id;
					}

					function getMetadataIcon() {
						if (vm.data.id != undefined || vm.data.metadata_id) {
							var id =
								vm.data.metadata_id != undefined
									? vm.data.metadata_id
									: vm.data.id;
							PictogrammeService.getPictogrammeByMetatDataId(id).then(function (
								response
							) {
								vm.data.icon_id = response.data;
								buildIconUrl();
							});
						}
					}

					function updateTagPosition(from, available) {
						for (let i = 0; i < from.length; i++) {
							from[i].position = i;
						}
						// Refresh selected
						_.each(available, function (elm) {
							elm.selected = elementAlreadySelected(from, elm);
						});
					}

					function elementAlreadySelected(from, tag) {
						if (from.length === 0) {
							return false;
						}
						return (
							_.find(from, function (t) {
								return t.code === tag.code;
							}) !== undefined
						);
					}
				},
			];

			return {
				restrict: 'E',

				scope: {
					data: '=',
					hasCatalogue: '=',
					datacatalogueDisabled: '=',
					elementId: '=',
					callback: '&',
					expression: '@',
					disabled: '=',
					isNew: '=',
					disableCode: '=',
					enableCode: '=',
					config: '=',
					withGroupingTags: '<',
				},
				controller: controller,
				controllerAs: 'vm',
				//required in 1.3+ with controllerAs
				bindToController: true,
				templateUrl: './src/components/directives/metadata/metadata.html',
				link: function (scope, element, attrs, $ctrl) {
					$ctrl.isReferenced =
						$ctrl.hasCatalogue === $ctrl.metadataCatalogueRefStatus.active;

					$ctrl.withGroupingTags = scope.vm.withGroupingTags ?? false;

					scope.$watch(
						function () {
							return scope.vm.data;
						},
						function (newValue, OldValue) {
							if (newValue && newValue !== OldValue) {
								scope.vm.sortTags();
							}
						}
					);

					scope.$watch(
						function () {
							return scope.vm.isNew;
						},
						function (newValue, OldValue) {
							if (newValue !== OldValue) {
								scope.vm.hide_advanced = !newValue;
							}
						}
					);

					scope.$watch(
						function () {
							return scope.vm.disableCode;
						},
						function (newValue, OldValue) {
							if (newValue !== OldValue) {
								scope.vm.disableCode = newValue;
							}
						}
					);
				},
			};
		},
	]);
})();
